import {post} from '@/utils/request';
import{mqserver} from '@/utils/baseUrl';
//消费服务下拉查询
export async function getConsumerServerDropDownList(params) {
    return post(mqserver+'/consumerServer/getConsumerServerDropDownList', params, true)
}
//消费信息列表查询
export async function getConsumerServerInfoList(params) {
    return post(mqserver+'/consumerServer/getConsumerServerInfoList', params, true)
}
//消费服务详情删除
export async function delConsumerServerInfo(params) {
    return post(mqserver+'/consumerServer/delConsumerServerInfo', params, true)
}
//消费服务是否使用验证
export async function validateConsumerUser(params) {
    return post(mqserver+'/consumerServer/validateConsumerUsed', params, true)
}
//消费服务详情保存
export async function saveConsumerServerInfo(params) {
    return post(mqserver+'/consumerServer/saveConsumerServerInfo', params, true)
}
//消费服务详情查询
export async function getConsumerServerDetail(params) {
    return post(mqserver+'/consumerServer/getConsumerServerDetail', params, true)
}